import '../activity/activity.css';

const pills = (isMemberView) => [
  { key: 'all', label: 'All' },
  { key: 'signin', label: 'Sign in with Google' },
  // IT and HR read someone else's list: "your data" would be about the viewer.
  { key: 'access', label: isMemberView ? 'Access to their data' : 'Access to your data' },
];

// Single-select chips, the same control as the Activity tab's category filter
// (`.act-chip`, aria-pressed) so sibling tabs don't use three filter styles.
// One chip is always pressed: clicking the pressed one keeps it.
export default function AppFilters({ value, counts, onChange, isMemberView = false }) {
  return (
    <div className="ca-filters act-chips" role="group" aria-label="Filter connected apps">
      {pills(isMemberView).map((p) => {
        const pressed = value === p.key;
        return (
          <button key={p.key} type="button" aria-pressed={pressed}
            className={`act-chip${pressed ? ' is-active' : ''}`}
            onClick={() => onChange(p.key)}>
            {`${p.label} (${counts[p.key]})`}
          </button>
        );
      })}
    </div>
  );
}
